export default {
  editorContainer: {
    minHeight: '200px',
  },
};
